/* eslint-disable no-console */

import {
    FETCH_USERS,
    FETCH_SUPPLIERS,
    FETCH_BUILDINGS,
    FETCH_BUILDING,
    ADD_BUILDING,
    UPDATE_BUILDING,
    DELETE_BUILDING,
    FETCH_FIELD,
    DELETE_FIELD,
    FETCH_PANEL_STATUSES,
    ADD_PANEL,
    UPDATE_PANEL,
    DELETE_PANEL,
    UPDATE_ALL_PANEL_PRICES,
    UPDATE_USER,
    CREATE_USER,
    CREATE_SUPPLIER,
    UPDATE_SUPPLIER,
    DELETE_ORDER,
    FETCH_ORDERS,
    FETCH_ORDERS_BY_PAGE,
    ORDER_STATUS_UPDATE,
    ORDER_COMMENT_UPDATE,
    EXPORT_ORDERS,
    UPLOAD_PANEL_PRICE,
    UPLOAD_PANEL_PRICE_SINGLE,
    DELETE_PANEL_PRICE_SINGLE,
    DOWNLOAD_PANEL_PRICES,
    FETCH_WORDING,
    DELETE_ORDER_PANEL, FETCH_ROLES, UPDATE_SUPPLIER_SETTINGS, DELETE_USER,
} from './types';
import api from '../util/api';
import wordingService from '../components/pages/wording/wordingService';

export default {
    [FETCH_WORDING] (context) {
        if (context.state.wordings) {
            return context.state.wordings;
        }

        return wordingService.list().then((resp) => {
            context.commit(FETCH_WORDING, resp);
            return resp;
        });
    },
    [FETCH_ORDERS] (context, searchParam) {
        const url = searchParam ? `/order${searchParam}` : '/order';
        return api.get(url)
            .then((resp) => {
                context.commit(FETCH_ORDERS, resp);
                return resp;
            });
    },
    [FETCH_ORDERS_BY_PAGE] (context, querySearch) {
        return api.get(`/order${querySearch}`)
            .then((resp) => {
                context.commit(FETCH_ORDERS, resp);
                return resp;
            });
    },
    [EXPORT_ORDERS] (context, searchParam) {
        const url = searchParam ? `/order/export${searchParam}` : '/order/export';
        return api.getFileLink(url);
    },
    [ORDER_COMMENT_UPDATE] (context, { orderId, comment }) {
        const url = `/order/${orderId}/update-comment`;
        return api.post(url, { comment }).then((resp) => {
            context.commit(ORDER_COMMENT_UPDATE, resp.data);
            return resp;
        });
    },
    [ORDER_STATUS_UPDATE] (context, { id, status }) {
        const url = `/order/status/${id}`;
        return api.put(url, { status }).then((resp) => {
            context.commit(ORDER_STATUS_UPDATE, resp.data);
            return resp;
        });
    },
    [DELETE_ORDER] (context, orderId) {
        const url = `/order/${orderId}`;
        return api.delete(url).then((resp) => {
            context.commit(DELETE_ORDER, orderId);
            return resp;
        });
    },
    [DELETE_ORDER_PANEL] (context, orderPanel) {
        const url = `/order/${orderPanel.pivot.order_id}/panel/${orderPanel.id}`;
        return api.delete(url).then((resp) => {
            context.commit(DELETE_ORDER_PANEL, resp.data);
            return resp;
        });
    },
    [FETCH_USERS] (context) {
        if (context.state.users) {
            return context.state.users;
        }

        return api.get('/user')
            .then((resp) => {
                context.commit(FETCH_USERS, resp);
                return resp;
            });
    },
    [FETCH_ROLES] (context) {
        if (context.state.roles) {
            return context.state.roles;
        }

        return api.get('/role')
            .then((resp) => {
                context.commit(FETCH_ROLES, resp);
                return resp;
            });
    },
    [CREATE_USER] (context, user) {
        return api.post('/user', user).then((resp) => {
            context.commit(CREATE_USER, resp.data);
            return resp;
        });
    },
    [UPDATE_USER] (context, data) {
        return api.put(`/user/${data.id}`, data).then((resp) => {
            context.commit(UPDATE_USER, resp.data);
            return resp;
        });
    },
    [DELETE_USER] (context, userId) {
        return api.delete(`/user/${userId}`).then((resp) => {
            context.commit(DELETE_USER, userId);
            return resp;
        });
    },
    [FETCH_SUPPLIERS] (context) {
        if (context.state.suppliers) {
            return context.state.suppliers;
        }

        return api.get('/supplier')
            .then((resp) => {
                context.commit(FETCH_SUPPLIERS, resp);
                return resp;
            });
    },
    [CREATE_SUPPLIER] (context, data) {
        const url = '/supplier/create';
        return api.post(url, data).then((resp) => {
            context.commit(CREATE_SUPPLIER, resp.data);
            return resp;
        });
    },
    [UPDATE_SUPPLIER] (context, data) {
        const url = `/supplier/update/${data.id}`;
        return api.post(url, data.formData).then((resp) => {
            context.commit(UPDATE_SUPPLIER, resp.data);
            return resp;
        });
    },
    [UPDATE_SUPPLIER_SETTINGS] (context, data) {
        const url = `/supplier/${data.supplier_id}/settings`;
        return api.put(url, data).then((resp) => {
            context.commit(UPDATE_SUPPLIER_SETTINGS, resp.data);
            return resp;
        });
    },
    [FETCH_BUILDINGS] (context) {
        return api.get('/building')
            .then((resp) => {
                context.commit(FETCH_BUILDINGS, resp);
                return resp;
            });
    },
    [FETCH_BUILDING] (context, buildingId) {
        return api.get(`/building/${buildingId}`)
            .then((resp) => {
                context.commit(FETCH_BUILDING, resp.data);
                return resp.data;
            });
    },
    [ADD_BUILDING] (context, data) {
        const url = '/building/create';
        return api.post(url, data).then((resp) => {
            context.commit(ADD_BUILDING, resp.data);
            return resp;
        });
    },
    [UPDATE_BUILDING] (context, data) {
        const url = `/building/update/${data.id}`;

        return api.post(url, data).then((resp) => {
            context.commit(UPDATE_BUILDING, resp.data);
            return resp;
        });
    },
    [DELETE_BUILDING] (context, building) {
        const url = `/building/${building.id}`;
        return api.delete(url).then((resp) => {
            context.commit(DELETE_BUILDING, building);
            return resp;
        });
    },
    [FETCH_FIELD] (context, fieldId) {
        return api.get(`/field/${fieldId}`).then((resp) => {
            context.commit(FETCH_FIELD, resp.data);
            return resp;
        });
    },
    [FETCH_PANEL_STATUSES] (context) {
        if (context.state.panel_statuses) {
            return context.state.panel_statuses;
        }

        return api.get('/panel/statuses')
            .then((resp) => {
                context.commit(FETCH_PANEL_STATUSES, resp);
                return resp;
            });
    },
    [ADD_PANEL] (context, { fieldId, data }) {
        const url = `field/${fieldId}/panel/create`;
        return api.post(url, data).then((resp) => {
            context.commit(ADD_PANEL, resp.data);
            return resp;
        });
    },
    [UPDATE_PANEL] (context, data) {
        const url = `/panel/${data.id}`;
        return api.put(url, data).then((resp) => {
            context.commit(UPDATE_PANEL, resp.data);
            return resp;
        });
    },
    [DOWNLOAD_PANEL_PRICES] (context, buildingid) {
        const url = `/building/${buildingid}/panel-price`;
        return api.getFileLink(url);
    },
    [UPLOAD_PANEL_PRICE_SINGLE] (context, data) {
        const url = `/building/${data.buildingId}/panel-price-single`;
        return api.post(url, data).then((resp) => {
            context.commit(UPDATE_BUILDING, resp.data);
            return resp;
        });
    },
    [UPLOAD_PANEL_PRICE] (context, { buildingId, data }) {
        const url = `/building/${buildingId}/panel-price`;
        return api.post(url, data).then((resp) => {
            context.commit(UPDATE_BUILDING, resp.data);
            return resp;
        });
    },
    [DELETE_PANEL_PRICE_SINGLE] (context, data) {
        const url = `/building/${data.buildingId}/panel-price-single/delete`;
        return api.post(url, data).then((resp) => {
            context.commit(UPDATE_BUILDING, resp.data);
            return resp;
        });
    },
    [UPDATE_ALL_PANEL_PRICES] (context, data) {
        const url = `/field/${data.fieldId}/panels-cost`;
        return api.put(url, data).then((resp) => {
            // const commitData = { data: resp.data, price: data.cost };
            context.commit(UPDATE_ALL_PANEL_PRICES, resp.data);
            return resp;
        });
    },
    [DELETE_PANEL] (context, panel) {
        const url = `/panel/${panel.id}`;
        return api.delete(url).then((resp) => {
            context.commit(DELETE_PANEL, panel);
            return resp;
        });
    },
    [DELETE_FIELD] (context, { field, building }) {
        const url = `/field/${field.id}`;
        return api.delete(url).then((resp) => {
            context.commit(DELETE_FIELD, { field, building });
            return resp;
        });
    },
};




// WEBPACK FOOTER //
// ./src/store/actions.js